module.exports = __webpack_public_path__ + "img/qybg.e403421d.png";